import { assertSecureApiTransport } from './secureTransport';

function isDevelopment(): boolean {
  return (
    import.meta.env?.DEV === true ||
    import.meta.env?.MODE === 'development' ||
    process.env.NODE_ENV === 'development'
  );
}

function readApiUrl(): string {
  const viteUrl = import.meta.env?.VITE_API_URL;
  const craUrl = process.env.REACT_APP_API_URL;

  // Same-origin /api proxy keeps the HttpOnly refresh cookie on the UI origin.
  if (isDevelopment()) {
    const proxyUrl = (craUrl || '/api').trim();
    if (proxyUrl.startsWith('/')) {
      return proxyUrl;
    }
  }

  return (viteUrl || craUrl || '').trim();
}

/**
 * Returns the API base URL and verifies it uses HTTPS in production.
 * Used by login, signup, and all authenticated API calls (axios).
 */
export function getApiBaseUrl(): string {
  const normalized = readApiUrl().replace(/\/$/, '');
  assertSecureApiTransport(normalized);
  return normalized;
}
